import styled from '@emotion/styled';
import { H3 as DefaultH3 } from '../../primitives';

export const H3 = styled(DefaultH3)`
  margin: 0;
`;
